import { Box, Button, CircularProgress, IconButton, RadioGroup, FormControlLabel, Radio, Typography, Tooltip } from '@mui/material';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import MaterialTable from 'material-table';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import Popup from "../../../Base/views/Popup"
import LeaveTypesPopup from './LeaveTypesPopup';
import ConfirmationDialog from '../../../Base/views/ConfirmationDialog';
import { DeleteLeaveTypeAction } from '../../../../../store/Leave/LeaveType/Action';
import "../../css/styles.css"
import PreviewIcon from '@mui/icons-material/Preview';
import { GetLeaveAccrualTypeHelper, UpdateLeaveAccrualTypeHelper } from '../../helper/LeaveTypeHelper';

const LeaveTypes = () => {

    const dispatch = useDispatch();
    const { leavetypes_options } = useSelector(state => state.LeaveReducer?.LeaveTypeReducer);

    const [editedRecord, setEditedRecord] = useState(null);
    const [openPopup, setOpenPopup] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [currentData, setCurrentData] = useState({});
    const [yearType, setYearType] = useState('calendar_year'); // financial_year, calendar_year
    const [yearTypeLoading, setYearTypeLoading] = useState(false);

    const getDateRange = () => {
        if (yearType === 'calendar_year') {
            return `Jan 1 - Dec 31`;
        } else if (yearType === "financial_year") {
            return `Apr 1 - Mar 31`;
        }
    };

    const handleEdit = (rowData) => {
        setEditedRecord(rowData);
        setOpenPopup(true);
    };

    const handleConfirmDelete = (rowData) => {
        setOpenDialog(true);
        setCurrentData(rowData)
    };

    const handleAdd = () => {
        setEditedRecord()
        setOpenPopup(true);
    };

    const handleDelete = () => {
        setOpenDialog(false);
        dispatch(DeleteLeaveTypeAction({ leavetype_id: `{${currentData?.leavetype_id}}` }))
    };

    const addMode = (resetForm) => {
        resetForm();
        setEditedRecord(null);
        setOpenPopup(false);
    };

    const addButton = <Button onClick={handleAdd} variant="contained" className="mpl-primary-btn" startIcon={<AddIcon />} >
        Add
    </Button>

    const handleYearTypeChange = (e) => {
        setYearTypeLoading(true);
        UpdateLeaveAccrualTypeHelper({ year_type: e.target.value }).then(res => {
            if (res?.data?.statuscode === 200) {
                setYearType(res?.data?.data?.[0]?.leave_acrrual_calendar || "")  
            } 
            setYearTypeLoading(false);
        })
    }
    useEffect(() => {
        setYearTypeLoading(true);
        GetLeaveAccrualTypeHelper().then(res => {
            if (res?.data?.statuscode === 200) {
                setYearType(res?.data?.data?.[0]?.leave_acrrual_calendar || "")
            }
            setYearTypeLoading(false);
        })
    }, [])

    return (
        <Box>
            <Box display="flex" justifyContent="flex-end" alignItems="center" gap={2}>
                {yearTypeLoading
                    ? <CircularProgress size={20} />
                    : (
                        <Box display="flex" alignItems="center" gap={0.5} pb={0.2}>
                            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>{getDateRange()}</Typography>
                            <Tooltip title="Based on this selection, your leave type credit cron job will run." arrow>
                                <InfoOutlinedIcon sx={{ fontSize: 18, color: 'gray', cursor: 'pointer', mb: 0.3 }} />
                            </Tooltip>
                        </Box>
                    )
                }
                <RadioGroup
                    row
                    value={yearType}
                    onChange={handleYearTypeChange}
                >
                    <FormControlLabel value="calendar_year" control={<Radio />} label="Calendar Year" />
                    <FormControlLabel value="financial_year" control={<Radio />} label="Financial Year" />
                </RadioGroup>
            </Box>
            <MaterialTable
                columns={[
                    { title: "Name", field: "name", cellStyle: { padding: "5px 10px 5px 10px" }, headerStyle: { padding: "0px 10px 0px 10px" } },
                    { title: "Code", field: "code", cellStyle: { padding: "5px 10px 5px 10px" } },
                    {
                        title: "Credit Type", field: "leave_type", cellStyle: { padding: "0px 10px 0px 5px"  },
                        render: rowData => rowData.leave_type === "flat" ? "Flat" : rowData.leave_type === "variable" ? "Variable" : "-"
                    },
                    {   title: "Credit Days", 
                        field: "actual_days", 
                        render: rowData => rowData.leave_type === "flat" ? rowData.actual_days : 
                        rowData?.credit_type === "monthly_accrual" ? rowData?.monthly_credit : 
                        rowData?.credit_type === "yearly_accrual" ? rowData?.yearly_credit : "-",
                        cellStyle: { padding: "0px 10px 0px 5px" }},
                    {
                        title: "Carry Forward?", field: "cfwd_leave", cellStyle: { padding: "0px 10px 0px 2%"},
                        render: rowData => {
                            return rowData?.name === "Compensatory Off" ? "-" : rowData.cfwd_leave ? <TaskAltIcon sx={{ color: "rgb(86, 202, 0)" }} />
                                : <HighlightOffIcon sx={{ color: "rgb(255, 76, 81)" }} />
                        }
                    },
                    { title: "Carry Forward Days", field: "noof_cfwd_days", cellStyle: { padding: "0px 10px 0px 5px" },
                      render: rowData => rowData?.noof_cfwd_days || "-"
                    },
                    {
                        title: "Gender Based", field: "gender_based", cellStyle: { padding: "0px 10px 0px 2%"},
                        render: rowData => {
                            return rowData?.name === "Compensatory Off" ? "-" : rowData.gender_based ? <TaskAltIcon sx={{ color: "rgb(86, 202, 0)" }} />
                                : <HighlightOffIcon sx={{ color: "rgb(255, 76, 81)" }} />
                        }
                    },
                ]}
                data={leavetypes_options || []}
                options={{
                    maxBodyHeight: 385,
                    rowStyle: { fontSize: "13px" },
                    headerStyle: { padding: "0px 10px 0px 0px", fontWeight: "bold" },
                    sorting: true,
                    search: true,
                    searchText: "",
                    searchFieldAlignment: "right",
                    searchAutoFocus: true,
                    searchFieldVariant: "standard",
                    filtering: false,
                    paging: true,
                    pageSizeOptions: [25, 50],
                    pageSize: 25,
                    paginationType: "stepped",
                    showFirstLastPageButtons: false,
                    paginationPosition: "bottom",
                    exportButton: false,
                    exportAllData: true,
                    addRowPosition: "first",
                    selection: false,
                    actionsColumnIndex: -1,
                    showSelectAllCheckbox: true,
                    showTextRowsSelected: true,
                    grouping: false,
                    columnsButton: true,
                }}
                onSelectionChange={(rows) => { return (rows.filter(row => row?.status === "Submitted")) }}
                actions={[
                    rowData => {
                        const disabled = rowData?.name === "Compensatory Off";
                        return {
                            icon: () => (
                                disabled ? null :
                                <IconButton
                                    sx={{
                                        padding: "0px",
                                        color: disabled ? "#bdbdbd" : "#637381",
                                    }}
                                    disabled={disabled}
                                >
                                    <PreviewIcon />
                                </IconButton>
                            ),
                            tooltip: "",
                            onClick: (_event, rowData) => { handleEdit(rowData) },
                            disabled,
                        };
                    },
                    // {
                    //     icon: () => <IconButton sx={{ padding: "0px" }}><DeleteIcon /></IconButton>,
                    //     tooltip: "Delete",
                    //     onClick: (_event, rowData) => { handleConfirmDelete(rowData) },
                    // },
                ]}
                title={addButton}
            />
            <Popup
                title={editedRecord ? "Leave Type" : "Add Leave Type"}
                openPopup={openPopup}
                setOpenPopup={setOpenPopup}
            >
                <LeaveTypesPopup editedRecord={editedRecord} addMode={addMode} setOpenPopup={setOpenPopup} />
            </Popup>
            <ConfirmationDialog
                title="Do you wish to proceed?"
                openDialog={openDialog}
                closeDialog={setOpenDialog}
                popupTitle="Country Management"
                OkButtonText="Delete"
                onSubmit={handleDelete}
            />
        </Box>
    );
}

export default LeaveTypes;
